import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCA: CultureInfo = {
  name: 'fr-CA',
  displayName: 'French (Canada)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CA',
  parent: CultureInfoFr
};
